
import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';
import { ReturnPurposeEnum, ShiftEnum } from '../../../../../packages/shared-models/src';

@Entity('stock_return')
export class NeedleReturnAfterProductionEntity {

    @PrimaryGeneratedColumn('increment', {
        name: 'id'
    })
    id: number;

    @Column('int', {
        name: 'job_id',
        nullable: false,
    })
    jobId: number;

    @Column('varchar', {
        name: 'return_qty',
        nullable: true,
    })
    returnQty: string;

    @Column('varchar', {
        name: 'remaining_qty',
        nullable: true,
    })
    remainingQty: string;

    @Column('varchar', {
        name: 'return_to',
        nullable: true,
    })
    returnTo: string;

    @Column('varchar', {
        name: 'return_by',
        nullable: true,
    })
    returnBy: string;

    @Column('boolean', {
        name: 'is_active',
        default: true,
    })
    isActive: boolean;

    @Column('datetime', {
        name: 'created_at',
        default: () => 'CURRENT_TIMESTAMP',
    })
    createdAt: Date;

    @Column('varchar', {
        name: 'created_user',
        nullable: true,
    })
    createdUser: string;

    @Column('datetime', {
        name: 'updated_at',
        nullable: true,
    })
    updatedAt: Date;

    @Column('varchar', {
        name: 'updated_user',
        nullable: true,
    })
    updatedUser: string;

    @Column('int', {
        name: 'version_flag',
        default: 1,
    })
    versionFlag: number;

    @Column('varchar', {
        name: 'company_code',
        nullable: true,
    })
    companyCode: string;

    @Column('enum', {
        name: 'return_purpose',
        enum: ReturnPurposeEnum,
        nullable: true
    })
    returnPurpose: ReturnPurposeEnum;

    @Column('enum', {
        name: 'shifts',
        enum: ShiftEnum,
        nullable: true
    })
    shifts: ShiftEnum;


    @Column('datetime', {
        name: 'date_of_return',
        nullable: true
    })
    dateOfReturn: string;

    @Column('varchar', {
        name: 'no_of_pieces',
        nullable: true,
    })
    noOfPieces: string;

}
